module.exports = __webpack_public_path__ + "img/shape_circle--black.a413317.png";